import { useState, useEffect } from "react";
import api from "../../utils/api";
import { INP, LBL, S, THEME } from "./AdminComponents";
import { useLanguage } from "../../context/LanguageContext";

const { G, G3 } = THEME;

const DEFAULT_SETTINGS = {
  siteName: "भोलिको इटहरी", tagline: "भिजन २०५० अभियान",
  contactEmail: "", contactPhone: "", address: "इटहरी, सुनसरी", announcement: "",
};

const CONTENT = {
  ne: {
    loading:            "सेटिङ लोड हुँदैछ…",
    savedMsg:           "✓ सेटिङ सफलतापूर्वक सुरक्षित भयो",
    sectionTitle:       "⚙ साइट सेटिङ",
    fields: [
      { label: "साइटको नाम",   name: "siteName",     type: "text"  },
      { label: "ट्यागलाइन",    name: "tagline",      type: "text"  },
      { label: "सम्पर्क इमेल", name: "contactEmail", type: "email" },
      { label: "सम्पर्क फोन",  name: "contactPhone", type: "text"  },
      { label: "ठेगाना",       name: "address",      type: "text"  },
    ],
    lblAnnouncement:    "घोषणा ब्यानर (साइटमा देखिने)",
    announcementPlaceholder: "वैकल्पिक घोषणा सन्देश…",
    saveBtn:            "💾 सेटिङ सुरक्षित गर्नुहोस्",
    savingBtn:          "सुरक्षित हुँदैछ…",
    reset:              "रिसेट",
    errLoad:            "सेटिङ लोड गर्न असफल भयो।",
    errSave:            "सुरक्षित गर्न असफल भयो।",
  },
  en: {
    loading:            "Loading settings…",
    savedMsg:           "✓ Settings saved successfully",
    sectionTitle:       "⚙ Site Settings",
    fields: [
      { label: "Site Name",     name: "siteName",     type: "text"  },
      { label: "Tagline",       name: "tagline",      type: "text"  },
      { label: "Contact Email", name: "contactEmail", type: "email" },
      { label: "Contact Phone", name: "contactPhone", type: "text"  },
      { label: "Address",       name: "address",      type: "text"  },
    ],
    lblAnnouncement:    "Announcement Banner (shown on site)",
    announcementPlaceholder: "Optional announcement message…",
    saveBtn:            "💾 Save Settings",
    savingBtn:          "Saving…",
    reset:              "Reset",
    errLoad:            "Failed to load settings.",
    errSave:            "Failed to save.",
  },
};

function SettingsPage() {
  const { language } = useLanguage();
  const t = CONTENT[language] || CONTENT.en;

  const [form, setForm]       = useState({ ...DEFAULT_SETTINGS });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState("");
  const [saved, setSaved]     = useState(false);

  useEffect(() => { fetchSettings(); }, []);

  async function fetchSettings() {
    setLoading(true); setError("");
    try {
      const res  = await api.get("/settings");
      const data = res.data?.data ?? res.data;
      setForm({
        siteName:     data.siteName     || "",
        tagline:      data.tagline      || "",
        contactEmail: data.contactEmail || "",
        contactPhone: data.contactPhone || "",
        address:      data.address      || "",
        announcement: data.announcement || "",
      });
    } catch (e) {
      setError(e.response?.data?.message || t.errLoad);
    } finally {
      setLoading(false);
    }
  }

  async function handleSave() {
    setSaving(true); setSaved(false);
    try {
      await api.put("/settings", form);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      alert(err.response?.data?.message || t.errSave);
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <div style={{ ...S.card, padding: 40, textAlign: "center", color: "#9ca3af" }}>{t.loading}</div>;
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 640 }}>
      {error && <div style={{ background: "rgba(239,68,68,0.08)", border: "1px solid #fca5a5", borderRadius: 8, padding: "10px 16px", color: "#ef4444", fontSize: 13 }}>⚠ {error}</div>}
      {saved && <div style={{ background: G3, border: `1px solid ${G}`, borderRadius: 8, padding: "10px 16px", color: G, fontSize: 13, fontWeight: 600 }}>{t.savedMsg}</div>}

      <div style={{ ...S.card, padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: "#111827", marginBottom: 4 }}>{t.sectionTitle}</div>

        {t.fields.map(({ label, name, type }) => (
          <div key={name}>
            <div style={LBL}>{label}</div>
            <input type={type} style={INP} value={form[name]} onChange={e => setForm({ ...form, [name]: e.target.value })} />
          </div>
        ))}

        <div>
          <div style={LBL}>{t.lblAnnouncement}</div>
          <textarea style={{ ...INP, minHeight: 80, resize: "vertical" }} value={form.announcement} onChange={e => setForm({ ...form, announcement: e.target.value })} placeholder={t.announcementPlaceholder} />
        </div>

        <div style={{ display: "flex", gap: 10, marginTop: 8 }}>
          <button onClick={handleSave} disabled={saving}
            style={{ flex: 1, padding: 10, borderRadius: 8, background: G, color: "#fff", border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer", opacity: saving ? 0.7 : 1 }}>
            {saving ? t.savingBtn : t.saveBtn}
          </button>
          <button onClick={fetchSettings}
            style={{ padding: "10px 20px", borderRadius: 8, background: "#f3f4f6", color: "#374151", border: "1px solid #e5e7eb", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
            {t.reset}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;